/**
 * Shared "is this signal a yes?" predicate.
 *
 * Offerings stats and org tags express affirmative signals
 * inconsistently — boolean `true`, the string `"true"`, or the string
 * `"yes"` (case-insensitive). Both the `tagLabels` bind transform (which
 * turns affirmative stats into pill labels) and the DataRepeater filter
 * (which keeps rows whose stats satisfy the active filter pills) must
 * agree on what counts, so the rule lives in one place. Mirrors legacy
 * Super Sonic `schoolDataPills#isAffirmative`.
 */
export function isAffirmative(value: unknown): boolean {
  if (value === true) {
    return true;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === 'true' || normalized === 'yes';
  }
  return false;
}
